<template>
  <div :class="{ container: !isPublic }">
    <div class="col-sm-12 card-group-row__col" v-for="item in research" :key="item.id">
      <div class="card overlay--show card-lg overlay--primary-dodger-blue card-group-row__card">
        <div class="card-header d-flex align-items-center justify-content-between">
          <div :class="isMediumScreen ? '' : 'd-flex align-items-center'">
            <a href="#" @click.prevent="openResearchProfile(item.id)" class="card-title flex mr-12pt">
              {{ item.title }}
            </a>
            <b-badge pill variant="primary" v-if="item.research_type !== JOB_TYPES.EXTERNAL"> Featured </b-badge>
          </div>

          <span>
            <i class="material-icons icon-16pt mb-1 mr-1 text-dark">account_balance</i>
            <span v-if="universityName(item)" class="text-primary" style="text-decoration: none">
              {{ universityName(item) }}
            </span>
            <a v-else href="#" @click.prevent>{{ item.ext_posted_by && item.ext_posted_by.name }}</a>
          </span>
        </div>
        <div class="card-body d-flex flex-column" @click.prevent="openResearchProfile(item.id)">
          <div class="d-flex align-items-center">
            <div class="flex">
              <div class="mb-16pt" :class="{ 'd-flex align-items-center': !isMobSmallScreen }">
                <div class="mr-12pt" :class="{ 'd-flex justify-content-center mb-3': isMobSmallScreen }">
                  <a
                    href="#"
                    @click.prevent
                    class="avatar avatar-xl overlay js-overlay overlay--primary rounded p-0 o-hidden d-flex justify-content-center align-items-center"
                    style="border: 1px solid #dfe2e6; object-fit: cover; height: inherit"
                  >
                    <img
                      class="avatar-img m-0 rounded"
                      :src="researchLogo(item)"
                      width="160"
                      height="auto"
                    />
                  </a>
                </div>
                <div class="flex">
                  <div class="mb-0" style="text-transform: none">
                    <div>
                      <i class="material-icons icon-16pt">location_on</i
                      ><strong style="font-weight: bold">{{ item.city }}, {{ item.state }}</strong>
                    </div>
                    <div>
                      <span>
                        <i class="material-icons icon-16pt">calendar_today</i> Posted
                        <strong style="font-weight: bold">{{ formatTimeAgo(item.created_at) }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-button">
            <p class="flex mb-0 mt-1">
              {{
                truncate(trim(stripHtmlTags(item.description)), {
                  length: 250,
                  separator: /,? +/,
                })
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatTimeAgo, stripHtmlTags } from '@/common/utils';
import { mapGetters } from 'vuex';
import { USER_ROLES, JOB_TYPES } from '../../common/constants';
import { truncate, trim, get } from 'lodash';

import DefaultAvatar from '@/assets/images/logos/logo_icon.png';

export default {
  name: 'ResearchCard',
  props: {
    research: { type: Array, default: () => [] },
    isPublic: { type: Boolean, default: false },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      DefaultAvatar,
      formatTimeAgo,
      USER_ROLES,
      JOB_TYPES,
    };
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
    isMediumScreen() {
      return this.windowWidth <= 776;
    },
    isMobSmallScreen() {
      return this.windowWidth <= 420;
    },
  },
  methods: {
    truncate,
    trim,
    stripHtmlTags,
    universityName(item) {
      return get(item, 'universities[0].name', null);
    },
    researchLogo(item) {
      return (
        get(item, 'universities[0].small_logo_url') ||
        get(item, 'ext_posted_by.small_logo_url') ||
        this.DefaultAvatar
      );
    },
    openResearchProfile(id) {
      if (this.isPublic) {
        this.$emit('viewMore', { name: 'student-research-details', params: { id } });
      } else {
        this.$router.push({ name: 'student-research-details', params: { id } });
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style>
</style>
